<template>
  <div ref="elementsPickerWrap" class="form-group">
    <label class="font-size-12">{{ label }}</label>
    <b-button ref="elementsPickerButton" variant="outline-primary" class="d-block inline-button" @click="toggleBox">
      <label class="mr-2">{{ value.length ? `${value.length} Element(s) Selected` : 'No Elements Selected' }}</label>
      <i :class="angleDownIcon" />
    </b-button>
    <div v-if="boxShown" ref="elementsPicker" class="position-relative">
      <ul class="elements-picker-wrap">
        <li v-for="(item, index) in items" :key="`item-${index}`" class="elements-picker-item" :data-item="item.id">
          <label :for="`elementsPicker-${index}`" class="custom-ellipsis elements-picker-item" :data-item="item.id">{{ item.label }}</label>
          <input
            type="checkbox"
            :id="`elementsPicker-${index}`"
            name="elementsPicker[]"
            class="elements-picker-item"
            :data-item="item.id"
            :value="item.id"
            :checked="!!value.includes(item.id)"
            @change="changeCheckbox"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ANGLEDOWN_ICON } from '@src/icons'
export default {
  props: {
    label: { type: String, default: null, required: true },
    items: { type: Array, default: null, required: true },
    ids: { type: Array, default: null, required: true },
    value: { type: Array, default: [] }
  },
  data() {
    return {
      angleDownIcon: ANGLEDOWN_ICON,
      boxShown: false
    }
  },
  computed: {
    idsInline() {
      return this.ids.join(',')
    }
  },
  watch: {
    idsInline: function() {
      this.refreshValue()
    }
  },
  mounted() {
    this.refreshValue()
  },
  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    callEvent(params) {
      this.$emit('callEvent', params)
    },
    refreshValue() {
      if (this.value.length) {
        const newValue = []
        this.value.forEach((singleId) => {
          if (this.ids.includes(singleId)) {
            newValue.push(singleId)
          }
        })
        this.$emit('input', newValue)
      }
    },
    removeListener() {
      document.body.removeEventListener('click', this.managePicker)
      if (this.$refs.elementsPickerWrap) {
        this.$refs.elementsPickerWrap.removeEventListener('mouseover', this.hoverActions)
      }
    },
    closeBox() {
      this.boxShown = false
      this.removeListener()
    },
    toggleBox() {
      if (!this.boxShown) {
        this.boxShown = true
        this.$nextTick(() => {
          document.body.addEventListener('click', this.managePicker)
          this.$refs.elementsPickerWrap.addEventListener('mouseover', this.hoverActions)
        })
      } else {
        this.closeBox()
      }
    },
    hoverActions(e) {
      if (e.target.classList.contains('elements-picker-item')) {
        const itemId = e.target.getAttribute('data-item')
        this.items.every((item) => {
          if (item.id === itemId) {
            this.callEvent({
              methodName: 'setHoverObject',
              eventData: item.data
            })
            return false
          }
          return true
        })
      } else {
        this.callEvent({
          methodName: 'setHoverObject',
          eventData: null
        })
      }
    },
    managePicker(e) {
      const $container = this.$refs.elementsPicker
      const $button = this.$refs.elementsPickerButton
      if (
        $container && $container !== e.target && !$container.contains(e.target) &&
        $button && $button !== e.target && !$button.contains(e.target)
      ) {
        this.closeBox()
      }
    },
    changeCheckbox(e) {
      const value = JSON.parse(JSON.stringify(this.value))
      const selectedValue = e.target.value
      if (e.target.checked && !value.includes(selectedValue)) {
        value.push(selectedValue)
      } else if (!e.target.checked) {
        const index = value.indexOf(selectedValue)
        if (index >= 0) {
          value.splice(index, 1)
        }
      }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
.elements-picker-wrap {
  width: 100%; max-height: 200px; overflow-x: hidden; overflow-y: auto; list-style: none; margin: 0; padding: 0; position: absolute; z-index: 10; top: 3px; left: 0; background: #FFFFFF; border: 1px solid #B0BACA; box-shadow: 0 1px 5px #0000004D;
  > li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1); display: flex; align-items: center;
    > label { flex: 1; margin: 0; font-size: 12px; padding: 0.5rem; }
    > input { margin-right: 0.5rem; }
    &:hover {
      cursor: pointer;
      > label { cursor: pointer; }
    }
  }
}
</style>